/**
 * ExcelHeader - Header component for excel-style table with sorting and filtering
 */

import React from "react";
import { TableHead, TableRow, TableSortLabel, Box } from "@material-ui/core";
import {
  COLUMN_MODES,
  EXCEL_COLUMNS,
  COLUMN_FILTER_CONFIG,
} from "../../../constants";
import {
  StickyHeaderFirstCell,
  StickyHeaderSecondCell,
  HeaderCell,
} from "../../styled";
import { ColumnFilter } from "../../molecules";

/**
 * Excel-style table header component
 * @param {Object} props
 * @param {string} props.columnMode - Column display mode
 * @param {string} props.orderBy - Current sort column
 * @param {string} props.order - Current sort direction
 * @param {Function} props.onSort - Sort handler
 * @param {Object} props.columnFilters - Current column filter selections
 * @param {Object} props.filterOptions - Available filter options
 * @param {Function} props.onFilterChange - Filter change handler
 */
const ExcelHeader = ({
  columnMode,
  orderBy,
  order,
  onSort,
  columnFilters,
  filterOptions,
  onFilterChange,
}) => {
  const createSortHandler = (columnId) => () => {
    onSort(columnId);
  };

  const getStickyHeaderComponent = (col) => {
    if (!col.sticky) return HeaderCell;
    if (col.stickyIndex === 1) return StickyHeaderSecondCell;
    return StickyHeaderFirstCell;
  };

  const getFilterForColumn = (colId) => COLUMN_FILTER_CONFIG[colId];

  return (
    <TableHead>
      <TableRow>
        {EXCEL_COLUMNS.filter(
          (col) => !col.monthly || columnMode === COLUMN_MODES.full
        ).map((col) => {
          const CellComponent = getStickyHeaderComponent(col);
          const filterConfig = getFilterForColumn(col.id);
          return (
            <CellComponent
              key={col.id}
              align={col.align}
              style={col.minWidth ? { minWidth: col.minWidth } : undefined}
            >
              <Box display="flex" alignItems="center">
                <TableSortLabel
                  active={orderBy === col.id}
                  direction={orderBy === col.id ? order : "asc"}
                  onClick={createSortHandler(col.id)}
                >
                  {col.label}
                </TableSortLabel>
                {filterConfig &&
                  filterOptions &&
                  filterOptions[filterConfig.key]?.length > 0 && (
                    <ColumnFilter
                      label={filterConfig.label}
                      options={filterOptions[filterConfig.key]}
                      selectedValues={columnFilters[filterConfig.key] || []}
                      onChange={(values) =>
                        onFilterChange(filterConfig.key, values)
                      }
                    />
                  )}
              </Box>
            </CellComponent>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default ExcelHeader;
